import { useContext, useEffect, useState } from "react";
import "./Footer.css";
import { LangContext } from "../../../Context/LangContext";
import { SOCIAL, baseURL } from "../../../Api/Api";
import axios from "axios";

function ScoMedia(props) {
  return (
    <>
      <li>
        <a href={props.useRef}>
          <i className={`${props.icon}`}></i>{" "}
        </a>
      </li>
    </>
  );
}
export default function Footer() {
  const langCtx = useContext(LangContext);
  const [instagram, setInstagram] = useState("");
  const [facebook, setFacebook] = useState("");
  const [twitter, setTwitter] = useState("");
  useEffect(() => {
    axios
      .get(`${baseURL}/${SOCIAL}`, {
        headers: {
          Accept: "application/json",
          "Accept-Language": `${langCtx}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          setInstagram(res.data.data.instagram);
          setFacebook(res.data.data.facebook);
          setTwitter(res.data.data.twitter);

        }
      })

  }, [langCtx]);
  
;

  return (
    <footer className="mt-4">
      <div className="main-container">
        <div className="logo-footer">
          <img src="/images/logo-footer.png" alt="logo-footer" />
        </div>

        <div className="sco-media">
          <ul>
          <ScoMedia useRef={instagram} icon="bi bi-instagram" />
          <ScoMedia useRef={facebook} icon="bi bi-facebook" />
          <ScoMedia useRef={twitter} icon="bi bi-instagram" />


          </ul>
        </div>
        <p className="copyright"> {text.Copyright[langCtx]} </p>
      </div>
      <div className="end-page">
      <a href="https://jaadara.com/" target="_blank" rel="noopener noreferrer">  {text.Jadara[langCtx]}  <i className="bi bi-heart-fill"></i> </a> 
      </div>
    </footer>
  );
}
const text = {
  Copyright: {
    ar: "جميع الحقوق محفوظة لشركة Personal Trainer",
    en: "All rights reserved to Personal Trainer",
  },
  Jadara: {
    ar:`صنع بكل حب  في معامل جدارة` ,
    en:`Made with love  in jadara ` ,
  }
};
